import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Collapse } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

import { errorHandler } from 'utils';

// Containers
import { useJobNotificationContext } from 'containers/common/JobNotificationProvider';

// Components
import { Mui } from 'components';
import { Drawer } from 'components/layouts';

function Export({ exportActions, actions, loading, open, onClose, title, description }) {
  const { trackJob } = useJobNotificationContext();
  const { sellerSlug } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const listToRender = exportActions || actions || [];

  const [exporting, setExporting] = useState(false);
  const [openGroups, setOpenGroups] = useState({});

  const toggleGroup = id => {
    setOpenGroups(prev => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const runAction = async actionObj => {
    if (!actionObj || !actionObj.action) return;

    const { action, params } = actionObj;

    try {
      setExporting(true);
      const res = await action({ sellerSlug, ...params });

      const { job: jobUid } = res?.data || {};
      if (jobUid) {
        trackJob(jobUid);
      }

      enqueueSnackbar('Recebemos sua solicitação, você será notificado em breve.', {
        variant: 'info',
      });

      onClose();
    } catch (err) {
      enqueueSnackbar(errorHandler(err?.response?.data) || 'Erro ao exportar dados.', {
        variant: 'error',
      });
    } finally {
      setExporting(false);
    }
  };

  const filteredList = Array.isArray(listToRender)
    ? listToRender.filter(item => !item?.hidden)
    : [];

  return (
    <Drawer
      onClose={onClose}
      title={title || 'Relatórios'}
      open={open}
      description={description || 'Estas são as opções de relatório disponíveis para exportação'}>
      <Mui.Container>
        <Mui.Card variant="outlined">
          <Mui.List style={{ padding: 0 }}>
            {filteredList.map((item, index) => {
              if (item.items && Array.isArray(item.items)) {
                return (
                  <React.Fragment key={item.label}>
                    <Mui.ListItem
                      button
                      onClick={() => toggleGroup(item.label)}
                      divider={index < filteredList.length - 1}>
                      <Mui.ListItemAvatar>
                        <Mui.Avatar>
                          <Mui.Icon>{item.icon}</Mui.Icon>
                        </Mui.Avatar>
                      </Mui.ListItemAvatar>

                      <Mui.ListItemText
                        primary={item.label}
                        primaryTypographyProps={{ fontWeight: 600 }}
                      />

                      <Mui.Icon color="disabled">
                        {openGroups[item.label] ? 'expand_less' : 'expand_more'}
                      </Mui.Icon>
                    </Mui.ListItem>

                    <Collapse in={openGroups[item.label]} timeout="auto" unmountOnExit>
                      <Mui.List component="div" disablePadding>
                        {item.items.map(subItem => (
                          <Mui.ListItem
                            button
                            key={`${item.label}-${subItem.label}`}
                            onClick={() => runAction(subItem)}
                            disabled={loading || exporting}
                            divider
                            style={{ paddingLeft: 56 }}>
                            <Mui.ListItemAvatar>
                              <Mui.Avatar>
                                <Mui.Icon>{subItem.icon}</Mui.Icon>
                              </Mui.Avatar>
                            </Mui.ListItemAvatar>

                            <Mui.ListItemText primary={subItem.label} />
                          </Mui.ListItem>
                        ))}
                      </Mui.List>
                    </Collapse>
                  </React.Fragment>
                );
              }

              return (
                <Mui.ListItem
                  key={item.label}
                  button
                  onClick={item.onClick ? item.onClick : () => runAction(item)}
                  disabled={loading || exporting}
                  divider={index < filteredList.length - 1}>
                  <Mui.ListItemAvatar>
                    <Mui.Avatar>
                      <Mui.Icon>{item.icon}</Mui.Icon>
                    </Mui.Avatar>
                  </Mui.ListItemAvatar>

                  <Mui.ListItemText primary={item.label} />
                </Mui.ListItem>
              );
            })}
          </Mui.List>
        </Mui.Card>
      </Mui.Container>
    </Drawer>
  );
}

Export.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  loading: PropTypes.bool,
  exportActions: PropTypes.array,
  actions: PropTypes.array,
};

export default Export;
